import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Typography as MuiTypography,
  Button as MuiButton,
  Box as MuiBox,
} from '@mui/material';

import { Icon } from 'components/ui';
import { countAge } from 'lib/utils';
import { SEX, sexData } from 'lib/enums/sex';
import Dialog from 'components/Dialogs';
import { SFrame, SAlignButton, SButton } from './styled/createSuccessDialog';
import { useTranslation } from 'react-i18next';
import { careTeamMemberRouteTemplates } from 'routing/routeTemplates';

function CreateSuccessDialog(props) {
  const history = useHistory();
  const location = useLocation();
  const { initialData = {}, close } = props;
  const { t } = useTranslation();

  if (!initialData) return null;
  const { patient } = initialData;

  const createNewPatient = () => {
    close({ createNew: true });
  };

  return (
    <Dialog {...props} onClose={close} title={t('Patient added')}>
      <SFrame>
        <MuiBox display="flex" p="20px 20px 30px">
          <Icon type="fal" icon="address-card" size="2x" />
          <MuiBox textAlign="left" ml="10px">
            <MuiTypography variant="h5">
              {patient.name.firstName?.[0]} {patient.name.lastName}
            </MuiTypography>
            <div>
              {patient.gender && patient.gender !== SEX.undefined && (
                <>
                  {/* <Icon icon={sexData[patient.gender.toUpperCase()].icon} size="1x" /> */}
                  <span style={{ margin: '5px' }}>&sdot;</span>
                </>
              )}
              {t(countAge(patient.birthDate).text, {
                age: countAge(patient.birthDate).age,
              })}
            </div>
          </MuiBox>
        </MuiBox>
        <SAlignButton>
          <MuiButton
            size="small"
            color="primary"
            variant="contained"
            onClick={() => {
              history.push(`/patientRecord/${patient.id}`, {
                from: {
                  pathname: location.pathname,
                  search: location.search,
                  fullUrl: location.pathname + location.search,
                  title: 'Patients',
                },
              });
            }}
          >
            <Icon icon="pen" size="1x" mr={10} /> {t('Edit record')}
          </MuiButton>
        </SAlignButton>
      </SFrame>

      <MuiBox display="flex" flexDirection="column" alignItems="center" mb={2}>
        {patient.notificationTypes && (
          <MuiTypography variant="subtitle1" gutterBottom>
            <Icon color="primary" size="1x" icon="envelope" mr={10} />
            {t('Invitation sent')}
          </MuiTypography>
        )}
        <SButton size="medium" variant="contained" onClick={createNewPatient}>
          <Icon icon="user-plus" size="1x" mr={5} /> {t('Add other patient')}
        </SButton>
      </MuiBox>
    </Dialog>
  );
}

export default CreateSuccessDialog;
